export var DeviceState;
(function (DeviceState) {
    DeviceState["ACTIVATED"] = "Activated";
    DeviceState["CREATED"] = "Created";
    DeviceState["DESTROYED"] = "Destroyed";
    DeviceState["REGISTERED"] = "Registered";
})(DeviceState || (DeviceState = {}));
